import { yang, canOfFood, toiletPaper, sanitzer, dareth } from "@/images";
import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

const interior = require("@/images/Supermarket_Interior.png");
const storeEmployee = require("@/images/Supermarket_Employee.png");

const aisle1Dialogs = [
  new Dialog(
    "Acquired 1 x LAST CAN OF FOOD",
    canOfFood,
    require("@/audio/Found_Jingle.mp3")
  ),
  new Dialog(
    "Acquired 1 x ROLL OF TOILET PAPER",
    toiletPaper,
    require("@/audio/Found_Jingle.mp3")
  ),
  new Dialog(
    "Acquired 1 x BOTTLE OF SANITIZER",
    sanitzer,
    require("@/audio/Found_Jingle.mp3")
  ),
  new Dialog(
    "SONNY YANG: Alright, time to bring these supplies to the automated checkout counter...",
    yang,
    require("@/audio/Pandemic_13_SonnyB-MP3.mp3")
  ),
  new Dialog(
    "DARETH SCHAMREN: Not so fast, Sonny Yang! Those supplies are owed to me by the grace of God himself, ya bastard!",
    dareth,
    require("@/audio/Pandemic_13_Dareth-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: Ugh... if it isn’t DARETH SCHAMREN.The least liked - person in town.",
    yang,
    require("@/audio/Pandemic_13_SonnyC-MP3.mp3")
  ),
];

const diaperSign = [
  new Dialog(
    "SONNY YANG: The sign reads: “Dear valued customers, we sincerely apologise for the global shortage of toilet paper we are currently experiencing and other occurrences which are entirely out of our control but somehow also our fault. In the meantime, please accept our surplus stock of ADULT DIAPERS as a temporary substitute.",
    interior,
    require("@/audio/Pandemic-100-Sonny-MP3.mp3")
  )
]
const buyDiapers = [
  new Dialog(
    "[Acquired 1 x PACK OF ADULT DIAPERS]",
    require("@/images/Adult_Diaper.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
];
export class SupermarketInterior extends Scene {
  title = "Inside Supermarket";

  async init() {
    this.description = "";
    this.audio = null;
    this.image = interior;
    if (this.state.storylines.findSupermarket) {
      this.state.storylines.findSupermarket = false;
      this.state.storylines.acquireSupplies = true;
    }
  }

  resetAudioKey() {
    this.audioKey = `${Math.random()}`;
  }

  get options(): any[] {
    const choices = [];

    if (this.state.storylines.acquireSupplies) {
      choices.push(
        new Choice("Buy Supplies", async () => {
          this.state.storylines.acquireSupplies = false;
          aisle1Dialogs[0].callback = () => {
            this.state.inventory.beans.has = true;
            this.resetAudioKey();
          };
          aisle1Dialogs[1].callback = () => {
            this.state.inventory.toiletPaper.has = true;
            this.resetAudioKey();
          };
          aisle1Dialogs[2].callback = () => {
            this.state.inventory.handSanitizer.has = true;
            this.resetAudioKey();
          };

          await this.dialogRunner(aisle1Dialogs)

          await this.navigate(scenes.FightScene());
        })
      );

      choices.push(
        new Choice("Talk to Store Employee", () => {
          this.description =
            "STORE EMPLOYEE: I’m under a lot of stress due to everything that’s happening. Please just take your items and leave.";
          this.image = storeEmployee;
          this.audio = require("@/audio/Pandemic_12_Supermarket_Employee-MP3.mp3");
        })
      );
    } else if (this.state.storylines.buyDiapers) {
      choices.push(
        new Choice("Buy Supplies", async () => {
          await this.dialogRunner(buyDiapers)
          this.description = "";
          this.image = interior;
          this.state.inventory.diapers.has = true;
          this.state.storylines.buyDiapers = false;
        })
      );

      choices.push(new Choice("Read Sign", async () => await this.dialogRunner(diaperSign)));
    } else {
      choices.push(
        new Choice("Buy Supplies", () => {
          this.image = interior;
          if (this.state.inventory.diapers.has) {
            this.description =
              "SONNY YANG: I don’t need any more adult diapers.";
            this.audio = require("@/audio/Pandemic-102-Sonny-MP3.mp3");
          } else {
            this.description = "[The shelves are empty]";
          }
        })
      );
    }
    if (!this.state.storylines.acquireSupplies) {
      choices.push(
        new Choice("Leave Supermarket ", async () =>
          await this.navigate(scenes.Supermarket())
        )
      );
    }
    return choices;
  }
}

export default new SupermarketInterior();
